import { AdminModal } from "./AdminModal"
import { SuperAdminUserOverview } from "./SuperAdminUserOverview"

export const SuperAdminUserOverviewModal = ({ token, userUid, onClose, onShowAllEvents }: { token: string; userUid: string; onClose: () => void; onShowAllEvents?: (uid: string) => void }) =>
	<AdminModal title='User overview' width={1120} closeOnBackdrop onClose={onClose}>
		<SuperAdminUserOverview key={userUid} token={token} initialUserUid={userUid} embedded onShowAllEvents={onShowAllEvents} />
	</AdminModal>
